import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, Minus } from 'lucide-react';
const FAQS = [{
  q: '¿Necesito experiencia previa?',
  a: 'No. Está pensado para principiantes.'
}, {
  q: '¿Es material digital?',
  a: 'Sí. Acceso inmediato.'
}, {
  q: '¿Es solo teoría?',
  a: 'No. Es práctica real y aplicable.'
}];
export function FAQSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="bg-white py-20 md:py-28 px-4" data-id="element-69">
      <div className="container mx-auto max-w-2xl" data-id="element-70">
        <h2 className="text-3xl md:text-5xl font-serif font-bold text-gray-900 text-center mb-14 leading-tight" data-id="element-71">
          ❓ Preguntas frecuentes
        </h2>

        <div className="space-y-3" data-id="element-72">
          {FAQS.map((faq, idx) => <div key={idx} className="border border-gray-200 rounded-xl bg-gray-50 overflow-hidden" data-id="element-73">
              <button onClick={() => setOpenIndex(openIndex === idx ? null : idx)} className="w-full flex items-center justify-between p-5 md:p-6 text-left hover:bg-gray-100 transition-colors" data-id="element-74">
                <span className="font-bold text-gray-900 text-lg" data-id="element-75">{faq.q}</span>
                {openIndex === idx ? <Minus className="w-5 h-5 text-amber-500 flex-shrink-0" data-id="element-76" /> : <Plus className="w-5 h-5 text-gray-400 flex-shrink-0" data-id="element-77" />}
              </button>
              <AnimatePresence data-id="element-78">
                {openIndex === idx && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: 'auto',
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-79">
                    <div className="px-5 md:px-6 pb-5 md:pb-6 text-gray-600 text-lg leading-relaxed border-t border-gray-200 pt-4" data-id="element-80">
                      {faq.a}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>)}
        </div>
      </div>
    </section>;
}